<template>
   <div class="slider" :class="{disabled:disabled, hideThumb:hideThumb}" >
    <v-row v-if="displayValuesInline" class="ma-0 mb-n2 token-text-medium">
      <div class=" ml-auto">
        <span v-if="range && insideValues">{{ insideValues[0] }} - {{ insideValues[1] }} {{ valuesInlineAppend }}</span>
        <span v-else-if="!range && insideValue">{{ insideValue }} {{ valuesInlineAppend }}</span>

      </div>
    </v-row>
    <v-row 
      :class="displayValuesInline ? 'ma-0': 'ma-2'"
     >
      <template v-if="range">
        <v-range-slider
          v-model="insideValues"
          :hide-details="true"
          :step="step || 1"
          :min="min"
          :max="max"
          :show-ticks="hideTicks ? false : 'always'"
          :thumb-label="hideThumbLabels ? false : 'always'"
          :disabled="disabled"
          tick-size="4"
          track-fill-color="rgba(50, 25, 178, 1)"
          track-color="rgba(0, 0, 58, 0.3)"
          @update:modelValue="updateValues"
        >
          <template #thumb-label="{ modelValue }">
            <slot name="thumb-label" :modelValue="modelValue">
              {{ modelValue }}
            </slot>
          </template>
        </v-range-slider>
      </template>
      <template v-else>
        <v-slider
          v-model="insideValue"
          :hide-details="true"
          :step="step || 1"
          :min="min"
          :max="max"
          :show-ticks="'always'"
          :thumb-label="hideThumbLabels ? false : 'always'"
          :disabled="disabled"
          tick-size="4"
          track-fill-color="rgba(50, 25, 178, 1)"
          track-color="rgba(0, 0, 58, 0.3)"
          @update:modelValue="updateValue"
          @end="end"
        >
          <template #thumb-label="{ modelValue }">
            <slot name="thumb-label" :modelValue="modelValue">
              {{ modelValue }}
            </slot>
          </template>
        </v-slider>
      </template>
     
    </v-row>
    </div>
</template>


<script lang="ts">
import { Vue, prop, Options } from 'vue-class-component';
import CustomButton from '@/components/UIElements/CustomButton.vue'
import { Watch } from 'vue-property-decorator';

class Props {
  values?: number[] = prop({
    required: false,
  });
  value?: number = prop({
    required: false,
  });
  step: number | undefined  = prop({
    required: false,
  });
  min: number | undefined = prop({
    required: false,
  });
  max: number | undefined = prop({
    required: false,
  });
  displayValuesInline: boolean | undefined = prop({
    required: false,
  });
  valuesInlineAppend: string | undefined = prop({
    required: false,
  });
  hideTicks: boolean | undefined = prop({
    required: false,
  });
  hideThumbLabels: boolean | undefined = prop({
    required: false,
  });
  hideThumb: boolean | undefined = prop({
    required: false,
  });
  range: boolean | undefined = prop({
    required: false,
  });
  disabled?: boolean = prop({
    required: false,
  });
}

@Options({
  components: {
    CustomButton
  },
})
export default class Slider extends Vue.with(Props) {

  insideValues:number[] | undefined = [0,0]
  insideValue:number | undefined = 0

  updateValues(values:number[]) {
    this.$emit('updateValue:values', values)
  }
  updateValue(value:number) {
    this.$emit('updateValue:value', value)
  }

  end(value:number) {
    this.$emit('end', value)
  }

  @Watch('values', {immediate : true})
  onValuesChange() {
    if(this.range && this.values !== undefined) {
      this.insideValues = this.values
    }
  }

  @Watch('value', {immediate : true})
  onValueChange() {
    if(!this.range && this.value !== undefined) {
      this.insideValue = this.value
    }
  }


}
</script>


<style lang="scss" scoped>
@import '@/css/variables';
.slider {
  width: 100%;
  :deep(.v-slider-thumb__surface) {
    color:white !important;
    border:1px solid $color-neutral-grey-12;
  }

  :deep(.v-slider-track__tick) {
    background-color:$color-neutral-grey-60 !important;
  }

  :deep(.v-slider-thumb__label) {
    background-color: $color-brand !important;
  }
  :deep(.v-slider-thumb__label:before) {
    color: $color-brand !important;
    bottom: -5px;
  }
  :deep(.v-slider-thumb__label) {
    height: fit-content;
    min-width: 25px;
    padding: 4px;
  }
  &.hideThumb {
    :deep(.v-slider-thumb) {
      display: none !important;
    }
  }
}
</style>
